exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sortable-ghost[data-v-3976fa2f]{opacity:.5;background:#f3f4f6!important}.sortable-chosen[data-v-3976fa2f]{background:#dbeafe!important;border-color:#3b82f6!important}.sortable-drag[data-v-3976fa2f]{opacity:.8}.sortable-fallback[data-v-3976fa2f]{opacity:.8;background:#dbeafe!important;border:2px solid #3b82f6!important;border-radius:4px;box-shadow:0 4px 6px -1px rgba(0,0,0,.1),0 2px 4px -1px rgba(0,0,0,.06)}.folder-drag-header[data-v-3976fa2f]{cursor:move}.sortable-chosen .folder-drag-header[data-v-3976fa2f]{cursor:move!important}", ""]);

// exports
